export const isTabVisible = (value) => value === true || value === 1 || value === '1';

export const sortDetailTabs = (tabs = []) =>
  [...tabs].sort(
    (a, b) =>
      Number(a.DisplayOrder || 0) - Number(b.DisplayOrder || 0) ||
      String(a.TabKey || '').localeCompare(String(b.TabKey || '')),
  );

const parseContentConfig = (value) => {
  if (value == null || value === '') return {};
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(String(value));
  } catch {
    return {};
  }
};

const normalizeTabRow = (tab) => ({
  ...tab,
  ContentConfig: parseContentConfig(tab.ContentConfig),
  Placement: tab.Placement || 'tab',
});

export const mergeDetailTabs = (detailTabs) =>
  sortDetailTabs((Array.isArray(detailTabs) ? detailTabs : []).map(normalizeTabRow));

export const getSidebarTabs = (detailTabs) =>
  mergeDetailTabs(detailTabs).filter(
    (tab) => tab.Placement === 'sidebar' && isTabVisible(tab.IsVisible),
  );

export const getVisibleDetailTabs = (detailTabs) =>
  mergeDetailTabs(detailTabs).filter(
    (tab) => tab.Placement !== 'sidebar' && isTabVisible(tab.IsVisible),
  );

export const getDetailTabTitle = (tab) => {
  if (!tab) return '';
  const title = (tab.TabTitle || '').trim();
  return title || tab.TypeDefaultTitle || tab.TabKey || '';
};

export const findDetailTab = (detailTabs, tabKey) => {
  const merged = mergeDetailTabs(detailTabs);
  return merged.find((tab) => tab.TabKey === tabKey) || null;
};
